<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('dashboard')">
      <template v-if="isTenantExist || tenant.is_single">
        <!--As per client requirements, this section is commented out-->
<!--                        <div class="d-flex">-->
<!--                            <app-punch-in-out @open-modal="openPunchInModal" @open-break-time="openBreakTimeModal"/>-->
<!--                            <button class="btn btn-outline-primary ml-3"-->
<!--                                    v-if="adminSummaryPermissions || employeeStatisticsPermissions || attendancePermissions"-->
<!--                                    @click="isAdmin = !isAdmin">-->
<!--                                {{ dashboardButtonLabel }}-->
<!--                            </button>-->
<!--                        </div>-->
        <!--As per client requirements, this section is commented out-->
      </template>
    </app-page-top-section>

    <app-employee-dashboard v-if="!isAdmin && !isBrandAdmin"/>

    <app-admin-dashboard v-if="isBrandAdmin || isAdmin"/>

    <punch-in-out-modal
        v-if="isModalActive"
        v-model="isModalActive"
        :punch="punchStatus"
        @close="isModalActive = false"/>

    <break-time-start-modal
        v-if="breakTimeModalActive"
        v-model="breakTimeModalActive"
        :break-times="breakTimes"
        :on-break="onBreak"
        :details-id="attendanceDetailsId"
    />

  </div>
</template>

<script>

import AppPunchInOut from "../Attendance/Component/AppPunchInOut";
import PunchInOutModal from "../Attendance/Component/PunchInOutModal";
import BreakTimeStartModal from "../Attendance/Component/BreakTimeStartModal";
// import {Shepherd} from 'shepherd.js';
import Shepherd from '../../../../../../packages/shepherd.js';
import '../../../../../../packages/shepherd.js/dist/css/shepherd.css';

export default {
  name: "Dashboard",
  components: {BreakTimeStartModal, PunchInOutModal, AppPunchInOut},
  data() {
    return {
      punchStatus: '',
      isModalActive: false,
      isAdmin: this.$isAdmin(),
      isBrandAdmin: this.$isTenantAdmin(),
      breakTimeModalActive: false,
      breakTimes: [],
      attendanceDetailsId: null,
      onBreak: null,
      dontShowAgain: false
    }
  },
  methods: {
    startTour() {
      const tour = new Shepherd.Tour({
        defaultStepOptions: {
          cancelIcon: {
            enabled: true
          },
          classes: 'shepherd-theme-custom',
          scrollTo: {behavior: 'smooth', block: 'center'},
        },
        useModalOverlay: true,
      });

      tour.addStep({
        id: 'step-1',
        title: "Employee",
        text: this.getStepContent(),
        attachTo: {
          element: '.employee_widget',
          on: 'top'
        },
        classes: 'custom-shepherd-step',
        buttons: [
          {
            text: 'Next',
            action: tour.next
          },
          {
            text: 'Skip',
            action: tour.complete
          }
        ]
      });

      tour.addStep({
        id: 'step-2',
        title: "Leave Request",
        text: 'This is the second step!',
        attachTo: {
          element: '#leave_widget',
          on: 'bottom'
        },
        classes: 'custom-shepherd-step',
        buttons: [
          {
            text: 'Next',
            action: tour.next
          },
          {
            text: 'Skip',
            action: tour.complete
          }
        ]
      });

      tour.addStep({
        id: 'step-2',
        title: "Total Attendance",
        text: 'This is the second step!',
        attachTo: {
          element: '#total-attendance',
          on: 'right'
        },
        classes: 'custom-shepherd-step',
        buttons: [
          {
            text: 'Next',
            action: tour.next
          },
          {
            text: 'Skip',
            action: tour.complete
          }
        ]
      });

      tour.addStep({
        id: 'step-2',
        title: "Employee Statistics",
        text: 'This is the second step!',
        attachTo: {
          element: '#employee-statistics',
          on: 'left'
        },
        classes: 'custom-shepherd-step',
        buttons: [
          {
            text: 'Finish',
            action: tour.complete
          }
        ]
      });
      tour.start();
    },
    getStepContent() {
      // Note the use of 'v-on:click' syntax for calling Vue methods directly
      return `<div class="shepherd-content">
          <p>This is a step with a checkbox for 'Don't show again.'</p>
          <label>
            <input type="checkbox" @click="() => this.dontShowAgain = !this.dontShowAgain;"> Don't show again
          </label>
        </div>`;
    },
    handleCheckbox(event) {
      console.log('test');
      this.dontShowAgain = event.target.checked;
      this.savePreference();
    },
    savePreference() {
      if (this.dontShowAgain) {
        localStorage.setItem('dontShowWizardAgain', 'true');
      } else {
        localStorage.setItem('dontShowWizardAgain', 'false');
      }
    },
    openPunchInModal(value) {
      this.punchStatus = value;
      this.isModalActive = true;
    },
    openBreakTimeModal(value, detailsId, onBreak) {
      this.breakTimes = value;
      this.onBreak = onBreak;
      this.attendanceDetailsId = detailsId;
      this.breakTimeModalActive = true;
    },
  },
  computed: {
    isTenantExist() {
      return !!window.tenant && !window.tenant.is_single;
    },
    tenant() {
      return window.tenant || {};
    },
    dashboardButtonLabel() {
      return this.isAdmin ? this.$t('view_as_employee')
          : (this.$isAdmin() ? this.$t('view_as_admin') : this.$t('view_as_manager'));
    },
    adminSummaryPermissions() {
      return this.$can('view_employees') ||
          this.$can('view_departments') || this.$can('view_all_leaves')
    },
    employeeStatisticsPermissions() {
      return this.$can('view_employment_statuses') ||
          this.$can('view_designations') || this.$can('view_departments')
    },
    attendancePermissions() {
      return this.$can('view_all_attendance')
    }
  },
  mounted() {
    // if (!JSON.parse(localStorage.getItem('dontShowWizardAgain'))) {
    //   this.startTour();
    // }
  },
  watch: {
    dontShowAgain: function (value) {
      console.log(value);
    }
  }
}
</script>

<style>
.custom-shepherd-step {
  background-color: #ffffff; /* Change background color */
  border: 2px solid #00acd4; /* Add a border */
  border-radius: 8px; /* Rounded corners */
  padding: 20px; /* Add padding */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Add a shadow */
}

.custom-shepherd-step .shepherd-title {
  font-size: 1.5em; /* Custom font size for title */
  color: #00acd4; /* Custom color for title */
}

.custom-shepherd-step .shepherd-text {
  font-size: 1em; /* Custom font size for text */
  color: #333; /* Custom color for text */
}

.custom-shepherd-step .shepherd-footer {
  display: flex;
  justify-content: space-between;
}

.custom-shepherd-step .shepherd-button {
  background-color: #00acd4; /* Custom button background */
  color: white; /* Custom button text color */
  border-radius: 5px; /* Rounded button corners */
  padding: 10px 20px; /* Button padding */
  border: none; /* Remove button border */
  cursor: pointer; /* Change cursor to pointer */
}

.custom-shepherd-step .shepherd-button:hover {
  background-color: #005f73; /* Darker color on hover */
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: #f0f2f5;
}

.shepherd-has-title .shepherd-content .shepherd-header > h3 {
  font-size: 1em;
}

.shepherd-cancel-icon {
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
}

.shepherd-cancel-icon span {
  line-height: 0;
}

.shepherd-cancel-icon:hover {
  background-color: #d5d5d5;
}

</style>